import { render, staticRenderFns } from "./LevelUpAtProfa_2020_09_17.vue?vue&type=template&id=1925563a&"
import script from "./LevelUpAtProfa_2020_09_17.vue?vue&type=script&lang=js&"
export * from "./LevelUpAtProfa_2020_09_17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports